module.exports = __webpack_public_path__ + "img/DP014.183f625b.png";